import { Component, effect } from "@angular/core";
import { Job } from "../../../models/CommonModels";
import { MainModel } from "../../../../global/model/MainModel";
import { JobsService } from "../../../../global/services/data/jobs-service/jobs.service";
import { NgFor, NgIf } from "@angular/common";
import { AsyncJobType } from "../../../models/ConstantsAndEnums";
import { SharedService } from "../../../services/shared.service";
import { JFCService } from "../../../services/jfc.service";
import { GenericButtonComponent } from "../../../../global/component/generic/generic-button/generic-button.component";

@Component({
    selector: 'app-jobs',
    standalone: true,
    imports: [
        NgFor,
        NgIf,
        GenericButtonComponent
  ],
  providers: [
    JobsService,
    SharedService,
    JFCService
  ],
    templateUrl: './jobs.component.html',
    styleUrl: './jobs.component.scss'
  })
  export class JobsComponent {

    AsyncJobType = AsyncJobType; // Expose the enum to the template
    campaignId: number = 0;
    jobs: Job[] = [];

    constructor(private mainModel: MainModel,
        private jobsService: JobsService,
        private sharedService: SharedService,
        private jfcService: JFCService
      )
    {
        effect(() => {
            const c: any = this.mainModel.selectedCampaign();
            const campaignId: number = parseInt(c?.campaignId);
            if (isNaN(campaignId))
            return;

            this.campaignId = campaignId;
            this.loadJobs();
        });
    }

    loadJobs(): void {
        this.jobsService.getJobs().subscribe({
          next: data => {
            this.jobs = data;
          },
          error: err => {
            console.error('Unable to load jobs. Please try again later.', err);
          }
        });
    }
    
    downloadJFCFile(category: string, filename: string) {
        
      const formData = new FormData();
      formData.append("category", category);
      formData.append("filename", filename);
      this.jfcService.downloadFile(formData).subscribe({
          next: blob => {
            this.sharedService.downloadFile(blob, filename);
          },
          error: err => {
            console.error('Unable to get distributions job report. Please try again later.', err);
          }
      });
  }
}